// extracted by mini-css-extract-plugin
export default {"firstCellFlex":"Style_firstCellFlex__YL+f4"};